export const READ_OCCUPANCY = 'shopperTrack/READ_OCCUPANCY'